<template>
  <div class="trade">
    <common-layout>
      <div slot="header">
        <h3>技术交易</h3>
      </div>
      <div slot="container">
        <div class="trade-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
            >批量删除</el-button
          >
          <el-button
            type="primary"
            class="exportOut"
            icon="el-icon-download"
            @click="exportOut"
            >导出</el-button
          >
          <el-date-picker
            v-model="time[0]"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="开始日期"
            @change="search('start')"
            style="width: 10%; margin: 0 5px 0 10px"
          >
          </el-date-picker>
          <span> - </span>
          <el-date-picker
            v-model="time[1]"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="结束日期"
            @change="search('end')"
            style="width: 140px; margin: 0 10px 0 5px"
          >
          </el-date-picker>
          <!-- <el-date-picker
            class="date-picker"
            v-model="time"
            type="daterange"
            @change="search"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 20%"
          ></el-date-picker> -->
          <el-select
            v-model="type"
            placeholder="请选择合作方式"
            @change="search()"
            style="width: 150px; margin-right: 20px"
          >
            <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="city"
            placeholder="请选择地区"
            @change="search()"
            @clear="search"
            clearable
            style="width: 150px; margin-right: 20px"
          >
            <el-option
              v-for="(item, index) in cityOption"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 270px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <el-select
            style="width: 170px; margin-right: 40px"
            v-model="srelease"
            clearable
            placeholder="请选择发布平台"
            @change="search"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2"/>
            <el-option label="成果交易平台" :value="3"/>
          </el-select>
          <el-button type="primary" @click="downFn">下载Excel模板</el-button>
          <el-button type="success" @click="exportFn">导入Excel</el-button>
        </div>
        <div class="trade-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="项目名称"
              align="center"
              prop="name"
            ></el-table-column>
            <el-table-column label="技术领域" align="center" prop="techField">
              <template slot-scope="scope">
                {{ formaVal(scope.row.techField) }}
              </template>
            </el-table-column>
            <el-table-column label="技术需求方" align="center" prop="need">
              <!-- <template slot-scope="scope">
								{{formaCasVal(scope.row.need_json)}}
							</template> -->
            </el-table-column>
            <el-table-column label="技术供给方" align="center" prop="provide">
              <!-- <template slot-scope="scope">
								{{formaCasVal(scope.row.provide_json)}}
							</template> -->
            </el-table-column>
            <el-table-column label="合作方式" align="center">
              <template slot-scope="scope">
                <span>{{
                  scope.row.type == 1
                    ? "技术开发"
                    : scope.row.type == 2
                    ? "技术转让"
                    : scope.row.type == 3
                    ? "技术咨询"
                    : scope.row.type == 4
                    ? "技术服务"
                    : "技术许可"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="技术交易额(万元)"
              align="center"
              prop="money"
            >
              <template slot-scope="scope">
                {{ Number(scope.row.money).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column label="免税金额(万元)" align="center" prop="free">
              <template slot-scope="scope">
                {{ Number(scope.row.free).toFixed(3) }}
              </template>
            </el-table-column>
            <el-table-column label="地区" align="center" prop="cityName">
              <!-- <template slot-scope="scope">
                {{ Number(scope.row.free).toFixed(2) }}
              </template> -->
            </el-table-column>
            <el-table-column
              label="当前状态日期"
              align="center"
              prop="day"
            ></el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{ scope.row.isAchievement === 1 && scope.row.isMarket === 1 ? '双平台' : (scope.row.isMarket === 1 ? '大市场平台' : '成果交易平台') }}
              </template>
            </el-table-column>
            <el-table-column width="180px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入项目名称"
                :disabled="Title == '编辑'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="技术领域" prop="techField">
              <el-select
                v-model="ruleForm.techField"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in filedOPtions"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="技术需求方" prop="need">
              <el-input
                v-model="ruleForm.need"
                placeholder="请输入技术需求方"
                :disabled="Title == '编辑'"
              ></el-input>
              <!-- <el-cascader placeholder="请选择" style="width:100%" v-model="ruleForm.need" :options="needArray" :props="{value:'id',label:'name',children:'sub'}"
							 clearable></el-cascader> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="技术供给方" prop="provide">
              <el-input
                v-model="ruleForm.provide"
                placeholder="请输入技术供给方"
                :disabled="Title == '编辑'"
              ></el-input>
              <!-- <el-cascader placeholder="请选择" style="width:100%" v-model="ruleForm.provide" :options="needArray" :props="{value:'id',label:'name',children:'sub'}"
							 clearable></el-cascader> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="合作方式" prop="type">
          <el-select
            style="width: 100%"
            v-model="ruleForm.type"
            placeholder="请选择合作方式"
            :disabled="Title == '编辑'"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区" prop="cityName">
          <el-select
            style="width: 100%"
            v-model="ruleForm.cityName"
            placeholder="请选择地区"
            :disabled="Title == '编辑'"
          >
            <el-option
              v-for="(item, index) in cityOption"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前状态时间" prop="day">
          <el-date-picker
            v-model="ruleForm.day"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%"
            :disabled="Title == '编辑'"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="金额(万)" prop="money">
          <el-input
            v-model="ruleForm.money"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="免税额度(万)" prop="free">
          <el-input
            v-model="ruleForm.free"
            placeholder="请输入免税额度"
          ></el-input>
        </el-form-item>
        <el-form-item label="签订合同" prop="crtUpload">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            name="file"
            accept=".jpg, .pgn, .pdf"
            :on-change="handleChange"
            :file-list="fileList"
            :on-remove="onRemove"
            :on-success="onSuccess"
            :show-file-list="true"
            :on-preview="onPreview"
            >点击上传</el-upload
          >
        </el-form-item>
        <el-form-item
                label="同步发布"
                prop="isMarket"
                style="text-align: left"
              >
                <el-select
                  v-model="isMarket"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="formmarket"
                >
                  <el-option label="双平台" :value="1"/>
                  <el-option label="大市场平台" :value="2"/>
                  <el-option label="成果交易平台" :value="3"/>
                </el-select>
              </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import { FunDownload, CheckTimeLine, ExportFn } from "../../utils/tool";
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      city: "",
      fileList: [],
      needArray: [],
      total: 10,
      per_page: 10,
      current_page: 1,
      type: "",
      time: [],
      Title: "",
      searchValue: "",
      srelease: '',
      dialogFormVisible: false,
      deleteRow: "",
      tableData: [],
      filedOPtions: [
        { label: "电子信息", value: 1 },
        { label: "航空航天", value: 2 },
        { label: "装备制造", value: 3 },
        { label: "生物、医药和医疗器械", value: 4 },
        { label: "新材料及其应用", value: 5 },
        { label: "新能源与高效节能", value: 6 },
        { label: "环境保护与资源综合利用", value: 7 },
        { label: "核应用", value: 8 },
        { label: "农业", value: 9 },
        { label: "现代交通", value: 10 },
        { label: "城市建设与社会发展", value: 11 },
      ],
      options: [
        {
          value: 1,
          label: "技术开发",
        },
        {
          value: 2,
          label: "技术转让",
        },
        {
          value: 3,
          label: "技术咨询",
        },
        {
          value: 4,
          label: "技术服务",
        },
        {
          value: 5,
          label: "技术许可",
        },
      ],
      options3: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "技术开发",
        },
        {
          value: 2,
          label: "技术转让",
        },
        {
          value: 3,
          label: "技术咨询",
        },
        {
          value: 4,
          label: "技术服务",
        },
        {
          value: 5,
          label: "技术许可",
        },
      ],
      isMarket:1,
      ruleForm: {
        name: "",
        need: "",
        provide: "",
        day: "",
        money: "",
        type: "",
        free: "",
        techField: "",
        cityName: "",
        isMarket : 1,
        isAchievement : 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        need: [
          {
            required: true,
            message: "请输入技术需求方",
            trigger: "blur",
          },
        ],
        provide: [
          {
            required: true,
            message: "请输入技术供给方",
            trigger: "blur",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入金额",
            trigger: "blur",
          },
        ],
        free: [
          {
            required: true,
            message: "请输入免税金额",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择合作方式",
            trigger: "change",
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择地区",
            trigger: "change",
          },
        ],
        day: [
          {
            type: "string",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        techField: [
          {
            required: true,
            message: "请选择技术领域",
            trigger: "change",
          },
        ],
      },
      cityOption: [],
    };
  },
  created() {
    this.getData("Technology_Item?status=4&ltype=1");
    this.getTree();
  },
  methods: {
    formmarket(val) {
      if(val === 1){
        this.ruleForm.isMarket = 1
        this.ruleForm.isAchievement = 1
      }else if(val === 2){
        this.ruleForm.isMarket = 1
        this.ruleForm.isAchievement = 2
      }else{
        this.ruleForm.isMarket = 2
        this.ruleForm.isAchievement = 1
      }
    },
    // 导入
    async exportFn() {
      // let res = await ExportFn('Technology_Item/import');
      let res = await ExportFn(`${urlConfig.devUrl}apij2/admin-api/voucher/item/import-excel`);
      /*if (res.code === 0 && res.data.is_export) {
        this.getData("Technology_Item?status=4&ltype=1");
        this.$message.success(`数据导入成功${res.data.suc_num || 0}条`);
      } else {
        this.$message.warning(`数据导入失败${res.data.fail_num || 0}条`);
      }*/

      if (res.code === 0) {
        this.$message.success("导入成功");
        this.search();
      } else {
        this.$message.error(res.status);
      }
    },
    //   下载
    downFn() {
      FunDownload(
        this.imgUrl + "lanzhoufile/技术交易模板.xlsx",
        "技术交易.xlsx"
      );
    },
    //导出
    exportOut() {
      // let url = window.urlConfig.url + "Technology_Item/export";
      let url = `${urlConfig.devUrl}apij2/admin-api/voucher/item/export-excel`;
      var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();
      this.visible = false;
      this.times = null;
    },
    formaVal(value) {
      let result = this.filedOPtions.filter((el) => {
        return el.value == value;
      });
      return result.length > 0 ? result[0].label : "--";
    },
    formaCasVal(val) {
      if (val) {
        let arrs = JSON.parse(val);
        let parent = [],
          subs = [],
          subs_s = [];
        parent = this.needArray.filter((el) => {
          return el.id == arrs[0];
        });
        subs =
          parent.length > 0 &&
          parent[0].sub &&
          parent[0].sub.filter((el) => {
            return el.id == arrs[1];
          });
        subs_s =
          subs &&
          subs[0].sub &&
          subs[0].sub.filter((el) => {
            return el.id == arrs[2];
          });
        return subs_s ? subs_s[0].name : subs ? subs[0].name : parent[0].name;
      }
    },
    onRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 获取绑定单位树
    getTree() {
      // this.http.get("Unit?all_sub=1").then((res) => {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user-bind-unit/getListAndTree`).then((res) => {
        if (res.code == 0) {
          this.needArray = res.data.data.tree;
        }
      });
    },
    onPreview(file) {
      FunDownload(this.imgUrl + file.url, file.name);
    },
    onSuccess(file, fileList, list) {
      this.fileList = list.map((el) => {
        return {
          name: el.name,
          url: el?.response?.data?.store_result || el?.url,
        };
      });
    },
    handleChange(file) {},

    getData(url) {
      let params = {
        ltype: 1,
        status: 4,
        page: this.current_page,
        name: this.searchValue,
        type: this.type || '',
        startDay: this?.time[0] || null,
        endDay: this?.time[1] || null,
        cityName: this.city || "",
      };
      if(this.srelease && this.srelease ===1){
        params.isMarket = 1
        params.isAchievement = 1
      }else if(this.srelease && this.srelease ===2){
        params.isMarket = 1
        params.isAchievement = 2
      }else if(this.srelease){
        params.isMarket = 2
        params.isAchievement = 1
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/item/pageLists`, params).then((res) => {
        if (res.code == 0) {
          this.cityOption = res.data.citys;
          this.tableData = res.data.pageResultList.data;
          this.total = res.data.pageResultList.total;
          this.per_page = res.data.pageResultList.per_page;
          this.current_page = res.data.pageResultList.current_page;
        }
      });
    },
    //新增
    addEvent() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.isMarket = 1
      this.ruleForm = {
        name: "",
        need: "",
        // need_id: "",
        // need_json: "",
        // provide_id: "",
        // provide_json: "",
        provide: "",
        day: "",
        money: "",
        type: "",
        free: "",
        cityName: "",
        isMarket : 1,
        isAchievement : 1,
      };
      this.fileList = [];
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/voucher/item/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.ResetSearch(["searchValue", "type"]);
                  this.time = [];
                  this.getData("Technology_Item?status=4&ltype=1");
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //搜索
    search(type) {
      if (this.time.filter((d) => d).length === 2) {
        let flag = CheckTimeLine(this.time[0], this.time[1]);

        if (flag) {
          if (type === "start") {
            this.$set(this.time, 0, "");
          } else {
            this.$set(this.time, 1, "");
          }

          return false;
        }
      }
      this.current_page = 1;
      this.getData(
        "Technology_Item?ltype=1&status=4&name=" +
          this.searchValue +
          (this.type ? "&type=" + this.type : "") +
          "&start_day=" +
          (this?.time[0] || "") +
          "&end_day=" +
          (this?.time[1] || "") +
          "&city_name=" +
          (this.city || "") + 
          (this.srelease ? (this.srelease === 1 ? "&is_market=1&is_achievement=1" : (this.srelease === 2 ? "&is_market=1&is_achievement=2" : "&is_market=2&is_achievement=1")) : '')
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.isMarket =  this.ruleForm.isAchievement === 1 &&  this.ruleForm.isMarket === 1 ? 1 : ( this.ruleForm.isMarket === 1 ? 2 : 3)
      // this.ruleForm.need = JSON.parse(this.ruleForm.need_json);
      // this.ruleForm.provide = JSON.parse(this.ruleForm.provide_json);
      this.ruleForm.money = Number(row.money).toFixed(2);
      this.ruleForm.free = Number(row.free).toFixed(3);
      if (row.contract) {
        let list = row.contract.split(",");

        this.fileList = list.map((el) => {
          let arr = el.split("/");
          return {
            name: arr[arr.length - 1],
            url: el,
          };
        });
      } else {
        this.fileList = [];
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/voucher/item/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.ResetSearch(["searchValue", "type"]);
                this.time = [];

                this.getData(`Technology_Item?status=4&ltype=1`);
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    handleCurrentChange(e) {
      this.current_page = e;
      this.getData(
        "Technology_Item?ltype=1&status=4&name=" +
          this.searchValue +
          "&page=" +
          e +
          (this.type ? "&type=" + this.type : "") +
          "&start_day=" +
          (this?.time[0] || "") +
          "&end_day=" +
          (this?.time[1] || "") +
          "&city_name=" +
          (this.city || "")+          
          (this.srelease ? (this.srelease === 1 ? "&is_market=1&is_achievement=1" : (this.srelease === 2 ? "&is_market=1&is_achievement=2" : "&is_market=2&is_achievement=1")) : '')
      );
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          function makeData() {
            obj.provide_id = obj.provide[obj.provide.length - 1];
            obj.provide_json = JSON.stringify(obj.provide);
            obj.need_id = obj.need[obj.need.length - 1];
            obj.need_json = JSON.stringify(obj.need);
            obj.need = undefined;
            obj.provide = undefined;
          }

          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          if (!this.ruleForm.id) {
            obj.status = 4;
            if (obj.money < 10) {
              obj.money_type = 1;
            } else if (obj.money >= 10 && obj.money < 20) {
              obj.money_type = 2;
            } else if (obj.money >= 20 && obj.money < 30) {
              obj.money_type = 3;
            } else if (obj.money >= 30 && obj.money < 40) {
              obj.money_type = 4;
            } else {
              obj.money_type = 5;
            }
            if (obj.free < 10) {
              obj.free_type = 1;
            } else if (obj.free >= 10 && obj.free < 20) {
              obj.free_type = 2;
            } else if (obj.free >= 20 && obj.free < 30) {
              obj.free_type = 3;
            } else if (obj.free >= 30 && obj.free < 40) {
              obj.free_type = 4;
            } else {
              obj.free_type = 5;
            }

            obj.day_four = obj.day;
            obj.contract = this.fileList
              .map((el) => {
                return el.url;
              })
              .join(",");
            // makeData();
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/item/create`, obj).then((res) => {
              if (res.code == 0) {
                this.ResetSearch(["searchValue", "type"]);
                this.time = [];
                this.current_page = 1;
                this.getData("Technology_Item?status=4&ltype=1");
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
              this.isMarket = 1
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              }
            });
          }
          if (this.Title == "编辑") {
            // delete obj.id;
            if (obj.money < 10) {
              obj.money_type = 1;
            } else if (obj.money >= 10 && obj.money < 20) {
              obj.money_type = 2;
            } else if (obj.money >= 20 && obj.money < 30) {
              obj.money_type = 3;
            } else if (obj.money >= 30 && obj.money < 40) {
              obj.money_type = 4;
            } else {
              obj.money_type = 5;
            }
            if (obj.free < 10) {
              obj.free_type = 1;
            } else if (obj.free >= 10 && obj.free < 20) {
              obj.free_type = 2;
            } else if (obj.free >= 20 && obj.free < 30) {
              obj.free_type = 3;
            } else if (obj.free >= 30 && obj.free < 40) {
              obj.free_type = 4;
            } else {
              obj.free_type = 5;
            }
            obj.day_four = obj.day;
            obj.contract = this.fileList
              .map((el) => {
                return el.url;
              })
              .join(",");
            obj.id = this.ruleForm.id;
            // makeData();
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/voucher/item/update`, obj)
              .then((res) => {
                this.ResetSearch(["searchValue", "type"]);
                this.time = [];

                if (res.code == 0) {
                  this.current_page = 1;
                  this.getData("Technology_Item?status=4&ltype=1");
                  this.$message({
                    type: "success",
                    message: "编辑成功",
                  });
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                }
              });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scope>
.upload-demo {
  border: 1px dashed #cccccc;
}

.trade {
  height: 100%;
  width: 100%;

  .trade-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
    }

    .el-input {
      // width: 400px;
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .trade-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
</style>
